import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useSession, signOut } from "../lib/auth.ts";
import { useStaff } from "../lib/staff.ts";

export function StaffLayout() {
  const { data: session } = useSession();
  // hasOrgMembership comes from the same /v1/staff/me fetch RequireStaff
  // already awaits before rendering this layout, so it's available on the
  // first paint — the "Client portal" link renders in its correct state
  // with no async flash. It's disabled when false because "/" would just
  // bounce a member-less staff user back to /staff.
  const { role, hasOrgMembership } = useStaff();
  const nav = useNavigate();

  return (
    <div className="layout">
      <header className="topbar">
        <div className="brand">
          BT-1851 Cloud
          <span className="muted" style={{ marginLeft: "0.5rem", fontWeight: 400 }}>
            · Staff
          </span>
        </div>
        <nav aria-label="Primary">
          <NavLink to="/staff" end>Orgs</NavLink>
          <NavLink to="/staff/assets">Assets</NavLink>
          {role === "admin" && <NavLink to="/staff/accounts">Accounts</NavLink>}
          <NavLink to="/staff/releases">Releases</NavLink>
          <NavLink to="/staff/battery-makers">Batteries</NavLink>
          {role === "admin" && <NavLink to="/staff/users">Staff</NavLink>}
          {role === "admin" && <NavLink to="/staff/oauth-clients">OAuth clients</NavLink>}
          {role === "admin" && <NavLink to="/staff/audit-log">Audit log</NavLink>}
          {role === "admin" && <NavLink to="/staff/backups">Backups</NavLink>}
          {role === "admin" && <NavLink to="/staff/attest-cas">Attestation CAs</NavLink>}
          {hasOrgMembership ? (
            <NavLink to="/">Client portal</NavLink>
          ) : (
            <span
              className="muted"
              aria-disabled="true"
              title="You're not a member of any client organisation"
              style={{ padding: "0.25rem 0.5rem", cursor: "not-allowed" }}
            >
              Client portal <em>(not a member)</em>
            </span>
          )}
        </nav>
        <div className="spacer" />
        <NavLink to="/account" className="muted" aria-label="Account settings">
          {session?.user?.email}
        </NavLink>
        <button
          className="secondary"
          aria-label="Sign out"
          onClick={async () => {
            await signOut();
            nav("/login");
          }}
        >
          Sign out
        </button>
      </header>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
